// extracted by mini-css-extract-plugin
export default {"heroTile":"Hero_heroTile__4GQTI","mlabel":"Hero_mlabel__SetXx","mno":"Hero_mno__ZcOdp","wordmark":"Hero_wordmark__GsM8G","dot":"Hero_dot__8mNpa","tagline":"Hero_tagline__k6eXa"};